import './TowerLoader.css'

function TowerLoader() {
  return (
    <div className="tower-loader">
      <div className="tower-box tower-box-1">
        <div className="tower-side-left"></div>
        <div className="tower-side-right"></div>
        <div className="tower-side-top"></div>
      </div>
      <div className="tower-box tower-box-2">
        <div className="tower-side-left"></div>
        <div className="tower-side-right"></div>
        <div className="tower-side-top"></div>
      </div>
      <div className="tower-box tower-box-3">
        <div className="tower-side-left"></div>
        <div className="tower-side-right"></div>
        <div className="tower-side-top"></div>
      </div>
      <div className="tower-box tower-box-4">
        <div className="tower-side-left"></div>
        <div className="tower-side-right"></div>
        <div className="tower-side-top"></div>
      </div>
    </div>
  )
}

export default TowerLoader

